/**
 * Filtragem AJAX de produtos — page-produto.js
 */
(function () {
  const form = document.getElementById("form-filtros");
  const grid = document.getElementById("produtos-grid");

  if (!form || !grid) return;

  if (typeof produtosAjax === "undefined") {
    console.error("[produtos] produtosAjax não definido — verifique wp_localize_script.");
    return;
  }

  /* -----------------------------------------------------------------------
   * Sync: label click → .c-checkbox
   *
   * O main.js cria um <span class="c-checkbox"> após cada <input> e ouve
   * 'click' apenas nele. Quando o usuário clica no texto do label ou em
   * qualquer outra parte do label, o browser alterna o input nativamente
   * mas o span visual não fica sabendo → dessincronia.
   *
   * Solução: interceptar o click no label, cancelar o comportamento nativo
   * e fazer o toggle manualmente mantendo o span em sync.
   * Se o clique vier do próprio .c-checkbox deixamos o main.js tratar.
   * ----------------------------------------------------------------------- */
  form.querySelectorAll(".filter-item label").forEach(function (label) {
    label.addEventListener("click", function (e) {
      // .c-checkbox já tem seu próprio handler no main.js — não interferir
      if (e.target.classList.contains("c-checkbox")) return;

      // Cancelar o toggle nativo do label (evita duplo-toggle)
      e.preventDefault();

      var checkbox = label.querySelector("input.filter-checkbox");
      var cCheckbox = label.querySelector(".c-checkbox");
      if (!checkbox) return;

      // Alternar estado
      checkbox.checked = !checkbox.checked;
      if (checkbox.checked) {
        checkbox.setAttribute("checked", "checked");
      } else {
        checkbox.removeAttribute("checked");
      }

      // Sincronizar span visual (pode não existir ainda se main.js não rodou)
      if (cCheckbox) {
        cCheckbox.classList.toggle("checked", checkbox.checked);
        cCheckbox.setAttribute("aria-checked", checkbox.checked ? "true" : "false");
      }

      // Disparar 'change' para o listener AJAX capturar (bubbles: true)
      checkbox.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });

  /* -----------------------------------------------------------------------
   * AJAX fetch
   * ----------------------------------------------------------------------- */
  function updateURL() {
    var urlParams = new URLSearchParams();
    var formData = new FormData(form);

    for (var pair of formData.entries()) {
      var key = pair[0];
      var val = pair[1];
      // Não incluir campos internos do AJAX na URL pública
      if (val !== "" && key !== "action" && key !== "nonce" && key !== "tipo_slug") {
        urlParams.append(key, val);
      }
    }

    var newQueryString = urlParams.toString();
    var newUrl = window.location.pathname + (newQueryString ? "?" + newQueryString : "");
    window.history.pushState({ path: newUrl }, "", newUrl);
  }

  function fetchProdutos() {
    var formData = new FormData(form);
    formData.append("action", "filter_produtos");
    formData.append("nonce", produtosAjax.nonce);
    formData.append("tipo_slug", produtosAjax.tipoSlug);

    grid.classList.add("is-loading");

    // Atualiza a URL do navegador com os filtros atuais
    updateURL();

    fetch(produtosAjax.ajaxurl, {
      method: "POST",
      credentials: "same-origin",
      body: formData,
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.success) {
          grid.innerHTML = data.data.html;
        }
      })
      .catch(function (err) {
        console.error("[produtos] Erro ao filtrar:", err);
      })
      .finally(function () {
        grid.classList.remove("is-loading");
      });
  }

  // Captura 'change' do input real (disparado tanto pelo main.js quanto pelo
  // label click acima) e aciona o AJAX.
  form.addEventListener("change", function (e) {
    if (e.target && e.target.classList.contains("filter-checkbox")) {
      var inputPaged = document.getElementById("input-paged");
      if (inputPaged) inputPaged.value = 1;
      fetchProdutos();
    }
  });

  /* -----------------------------------------------------------------------
   * Botões de ordenação (A-Z / Mais populares)
   * ----------------------------------------------------------------------- */
  var inputOrderby = document.getElementById("input-orderby");

  form.querySelectorAll(".sort-btn").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      var orderby = btn.getAttribute("data-orderby");

      // Toggle: clicou no mesmo botão ativo → reseta ordenação
      if (btn.classList.contains("active")) {
        btn.classList.remove("active");
        if (inputOrderby) inputOrderby.value = "";
      } else {
        // Remove active de todos, ativa o clicado
        form.querySelectorAll(".sort-btn").forEach(function (b) {
          b.classList.remove("active");
        });
        btn.classList.add("active");
        if (inputOrderby) inputOrderby.value = orderby;
      }

      var inputPaged = document.getElementById("input-paged");
      if (inputPaged) inputPaged.value = 1;

      fetchProdutos();
    });
  });

  /* -----------------------------------------------------------------------
   * Paginação AJAX
   * ----------------------------------------------------------------------- */
  grid.addEventListener("click", function (e) {
    var btn = e.target.closest(".pagination-produtos .page-numbers[data-page]");
    if (!btn) return;
    if (btn.disabled) return;

    var page = parseInt(btn.getAttribute("data-page"), 10);
    if (isNaN(page) || page < 1) return;

    var inputPaged = document.getElementById("input-paged");
    if (inputPaged) {
      inputPaged.value = page;
    }

    fetchProdutos();

    // Rolagem suave para o topo da lista de produtos
    var gridTop = grid.getBoundingClientRect().top + window.scrollY - 100;
    window.scrollTo({
      top: gridTop,
      behavior: "smooth",
    });
  });

  /* -----------------------------------------------------------------------
   * Animação suave para os acordeões (.faq-item)
   * ----------------------------------------------------------------------- */
  document.querySelectorAll(".faq-item").forEach(function (el) {
    var summary = el.querySelector("summary");
    var answer = el.querySelector(".faq-answer");
    if (!summary || !answer) return;

    summary.addEventListener("click", function (e) {
      e.preventDefault();

      if (el.classList.contains("is-animating")) return;
      el.classList.add("is-animating");

      if (el.hasAttribute("open")) {
        // Fechando
        answer.style.maxHeight = answer.scrollHeight + "px";
        answer.style.marginTop = "15px";
        answer.offsetHeight; // trigger reflow

        answer.style.maxHeight = "0px";
        answer.style.marginTop = "0px";

        setTimeout(function () {
          el.removeAttribute("open");
          el.classList.remove("is-animating");
        }, 300);
      } else {
        // Abrindo
        el.setAttribute("open", "");
        answer.style.maxHeight = "0px";
        answer.style.marginTop = "0px";
        answer.offsetHeight; // trigger reflow

        answer.style.maxHeight = answer.scrollHeight + "px";
        answer.style.marginTop = "15px";

        setTimeout(function () {
          answer.style.maxHeight = "none";
          el.classList.remove("is-animating");
        }, 300);
      }
    });
  });
})();
